import * as React from 'react'

import ParentReserveList from '~/organisms/reserve/ParentReserveList'
import YearMonthFilter from '~/atoms/filter/YearMonthFilter'
import * as Style from './style.css'

interface IProps {
  currentYear: number
  currentMonth: number
  showYear: number
  reserves: IReserveSummary[]
  monthClickhandler: (month: number) => Promise<void>
  yearClickhandler: (year: number) => void
}

export const ParentMonthlyReserveList = ({
  reserves,
  ...props
}: IProps): JSX.Element => {
  return (
    <div>
      <div className={Style.ParentMonthlyReserveListFilter}>
        <YearMonthFilter {...props} />
      </div>
      {reserves.length > 0 && (
        <div className={Style.ParentMonthlyReserveListContent}>
          <ParentReserveList reserves={reserves} />
        </div>
      )}
      {reserves.length === 0 && (
        <div className={Style.ParentMonthlyReserveListMessage}>
          予約はありません。
        </div>
      )}
    </div>
  )
}

export default ParentMonthlyReserveList
